<template>
    <div class="container p-5">
        <h1><strong>Ошибка 404</strong> Страница не найдена</h1>
        <p><router-link :to="-1">Вернуться назад</router-link></p>
    </div>
</template>


<script>
    export default {
        name: "NotFound",
    };
</script>
